import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, Button, Row, CustomInput } from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { Separator, Colxx } from '../../../../../../components/common/CustomBootstrap';
import { NudgesForm } from './NudgesForm';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Response, putAPI_Update_NudgesButton, gAPI_AllMessengers, gAPI_NudgesButtonList, putAPI_Update_Ingetration } from '../../../../../../constants/APIs';

export default function NudgesSetting({ integration, nudges, locale, integrationId }) {
  // console.log('nudges', nudges);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [nudgesData, setNudges] = useState([]);
  const [nudgeData, setNudge] = useState({});
  const [nudgeIndex, setNudgeIndex] = useState(0);
  const [messengerItems, setMessengerItems] = useState([]);
  const [isHideNudgeButton, setIsHideNudgeButton] = useState(false);

  useEffect(() => {
    console.log('integrationId', integrationId);
    const fetchNudgeSetting = async () => {
      try {
        const res = await AxiosAPI({
          method: "get",
          url: `${gAPI_NudgesButtonList}/${integrationId}?group_id=${getGroupID()}&lang=en-US`
        });
        if (res.data) {
          setIsHideNudgeButton(res.data?.hideNudgeClose || false);
        }
      } catch (err) {
        console.error("Error fetching nudge setting", err);
      }
    };
    fetchNudgeSetting();

    setNudges(nudges);
    let data = {
      groupId: getGroupID(),
      languageCode: "en",
      propertyId: integration.properties
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_AllMessengers}`,
      data: data
    }).then((res) => {
      const messengers = res.data.messengers.filter((item) => item.status === "Active");
      setMessengerItems(messengers);
    });
  }, [integrationId]);


  const edit = (data, index) => {

    setNudge(data);
    setNudgeIndex(index)
    setIsUpdating(true)
  }
  const handleSubmit = (eyeCatcherData, data) => {
    // console.log(eyeCatcherData);
    try {
      AxiosAPI({
        method: 'put',
        url: putAPI_Update_Response,
        data: eyeCatcherData,
      })
        .then((response) => {
          if (response.data.HttpStatusCode !== undefined && response.data.HttpStatusCode === 400 && response.data.Messages !== undefined
            && response.data.Messages !== null && response.data.Messages.length > 0) {
            setMsg(response.data.Messages);
            setOpen(true);
          }
          else {
            AxiosAPI({
              method: 'put',
              url: `${putAPI_Update_NudgesButton}/${integration.id}?group_id=${getGroupID()}`,
              data: data,
            })
              .then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                  && res.data.Messages !== null && res.data.Messages.length > 0) {
                  setMsg(res.data.Messages);
                  setOpen(true);
                }
                else {
                  // console.log(response.data);
                  nudgesData.forEach(n => {
                    if (n.eyeCatcher != undefined) {
                      if (n.eyeCatcher.query.code == eyeCatcherData.Code) {
                        n.eyeCatcher.response.messages = eyeCatcherData.Default;
                        n.delayInMilliseconds = data.delayInMilliseconds;
                        n.delayInMillisecondsInMobile = data.delayInMillisecondsInMobile;
                        n.disabledInDesktop = data.disabledInDesktop;
                        n.disabledInMobile = data.disabledInMobile;
                        n.buttons = data.buttons;
                        n.otherLanguages = data.otherLanguages;
                      }
                    }
                  });

                  setNudges(nudgesData);
                  setIsUpdating(false);
                }
              });
          }

        });
    } catch (error) {
      console.error(error);
    }
  };

  const handleCheckedNudgeButton = async (e) => {
    const value = e.target.checked;
    setIsHideNudgeButton(value);
    try {
      const res = await AxiosAPI({
        method: "put",
        url: `${putAPI_Update_Ingetration}/${integrationId}/nudgesmark-dismiss?groupId=${getGroupID()}`,
        data: {
          hideNudgeClose: value
        }
      });
      console.log("Nudge settings updated:", res.data);
    } catch (err) {
      console.error("Error updating nudge:", err);
    }
  }

  return (
    <Card className="mb-4">
      <CardBody>
        <h6 className="text-center">  <IntlMessages id='integration.nudges' /></h6>
        <Separator className="mb-3" />
        <div className="equal-height-container mb-5 row">
          {nudgesData && nudgesData.map((nudge, index) => (
            <div key={index} className="col-item mb-4 col-md-12 col-lg-6">
              <div className="card">
                <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
                  <div className="price-top-part">
                    <h5 className="mb-0 font-weight-semibold color-theme-1 mb-1">Eye Catcher</h5>
                    <p className="mb-2">
                      {nudge.eyeCatcher && nudge.eyeCatcher.response
                        ? nudge.eyeCatcher.response.messages[0]
                        : null}
                    </p>
                  </div>
                  <div className="pl-3 pr-3 pb-0 d-flex price-feature-list flex-column flex-grow-1">
                    <p className="text-center mb-2"><strong>Desktop</strong></p>
                    <Separator className="mb-3" />
                    <Row>
                      <Colxx sm={12} className="mb-2">
                        <Card className="text-center">
                          <div style={{ padding: "10px", marginTop: "0px" }}>
                            <b>Delay in Seconds</b><br />
                            <p className="mb-2">
                              {nudge.delayInMilliseconds
                                ? nudge.delayInMilliseconds / 1000
                                : null}
                            </p>
                            <b>Enabled</b><br />
                            <p>
                              {!nudge.disabledInDesktop
                                ? "Yes"
                                : "No"}
                            </p>
                          </div>
                        </Card>
                      </Colxx>
                    </Row>
                    <p className="text-center mb-2"><strong>Mobile</strong></p>
                    <Separator className="mb-3" />
                    <Row>
                      <Colxx sm={12} className="mb-2">
                        <Card className="text-center">
                          <div style={{ padding: "10px", marginTop: "0px" }}>
                            <b>Delay in Seconds</b><br />
                            <p className="mb-2">
                              {nudge.delayInMillisecondsInMobile ? nudge.delayInMillisecondsInMobile / 1000 : null}
                            </p>
                            <b>Enabled </b><br />
                            <p>
                              {!nudge.disabledInMobile
                                ? "Yes"
                                : "No"}
                            </p>
                          </div>
                        </Card>
                      </Colxx>
                    </Row>
                    {nudge.buttons !== null && nudge.buttons.length > 0 &&
                      <Fragment>
                        <p className="text-center mb-2"><strong>Buttons</strong></p>
                        <Separator className="mb-2"></Separator>
                        <Row>
                          <Colxx sm={12} className="mb-2">
                            <Card>
                              <div className='p-1 mt-1 text-center'>
                                {nudge.buttons.map((item, i) =>
                                  <span key={i} className="mb-1 mr-1 badge badge-outline-primary badge-pill">{item.text}</span>
                                )}
                              </div>
                            </Card>
                          </Colxx>
                        </Row>
                      </Fragment>
                    }
                    <Button
                      size="xs"
                      color="success"
                      outline
                      style={{ marginTop: '5px' }}
                      onClick={() => edit(nudge, index)}
                    >
                      Edit
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className='row px-5 my-3 align-items-center'>
            <div className='col-md-12'>
              <CustomInput
                key="isNudgeHideButton"
                type="checkbox"
                checked={isHideNudgeButton}
                onChange={(e) => handleCheckedNudgeButton(e)}
              >
                <span>Always Show Nudge unless cross is clicked</span>
              </CustomInput>
            </div>
          </div>
        </div>
      </CardBody >
      {isUpdating && (
        <NudgesForm
          formLabel="Update Nudges"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          submit={handleSubmit}
          nudgeData={nudgeData}
          nudgeIndex={nudgeIndex}
          messengerItems={messengerItems}
          integrationLanguages={integration.botSettings.languages}
          integrationId={integrationId}
          locale={locale}
        />)}
    </Card >
  );
}
